import { MeasureReferenceType } from "../enums/measure-reference-type";

export class MeasureReference {
    constructor() {
    }

    Code!: string;
    Name!: string;
    ChipName = '';
    Type: MeasureReferenceType = MeasureReferenceType.FDX;
    // MeasureCategory: MeasureCategory;
    Designation!: string;

    // public get TypeName(): string {
    //     switch (this.Type) {
    //         case MeasureReferenceType.Gax:
    //             return 'GA X';
    //         case MeasureReferenceType.None:
    //             return 'Hors GA X';
    //         default:
    //             return 'Not set';
    //     }
    // }

    static mapFromJSON(json: any): MeasureReference {
        const a = new MeasureReference;

        a.Code = json['code'];
        a.Name = json['name'];
        a.ChipName = json['chipName'];
        a.Type = json['type'];
        // a.MeasureCategory = json['measureCategory'];
        a.Designation = json['designation'];

        return a;
    }
}
